module.exports = __webpack_public_path__ + "static/media/celebration-icon.daa6dd44.svg";